import type { StockMovementType } from '../api/business/types';

export const STOCK_MOVEMENT_TYPES: Array<StockMovementType> = ['RECEIPT', 'ISSUE', 'ADJUSTMENT', 'WRITE_OFF'];
